import React, { useEffect } from 'react';

const ErrorLog = ({ children, isTest }) => {
  const LOGS_TO_STORE = ['log', 'error', 'info'];
  const MAX_LOG_COUNT = 50;

  const captureConsoleLogs = () => {
    // Create an object to store references to original console methods
    const originalConsoleMethods = {};

    LOGS_TO_STORE.forEach(method => {
      // Store a reference to the original console method
      originalConsoleMethods[method] = console[method];

      // Override console method
      console[method] = (...args) => {
        // Call the original console method
        originalConsoleMethods[method](...args);

        // save the logs in global variable
        if(method === 'log' || method === 'info'){
          (window as any).consoleLogList.push(args);

          if((window as any).consoleLogList?.length > MAX_LOG_COUNT){
            (window as any).consoleLogList.shift()
          }
        }
        if(method === 'error'){     
          (window as any).consoleErrorList.push(args);

          if((window as any).consoleErrorList?.length > MAX_LOG_COUNT){
            (window as any).consoleErrorList.shift()
          }
        }
      };
    });

    return originalConsoleMethods;
  };

  
  useEffect(() => {
    // Override console methods and get references to the originals
    if (isTest === true){
      return;
    }


    const originalConsoleMethods = captureConsoleLogs();

    // Clean up: Restore the original console methods when the component unmounts
    return () => {
      // Restore the original console methods
      LOGS_TO_STORE.forEach(method => {
        console[method] = originalConsoleMethods[method];
      });
    };
  }, []);

  return children;
};

export default ErrorLog;
